import React from "react";

const CentralKitchenInventoryModal = ({
    showModal,
    setShowModal,
    itemDetails,
    detailsLoading,
    detailsError
}) => {
    if (!showModal) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
            <div className="w-full max-w-7xl rounded-2xl bg-white shadow-2xl max-h-[90vh] overflow-hidden">

                <div className="flex items-center justify-between border-b px-6 pt-2.5 pb-2">
                    <div className="text-base font-semibold text-gray-800">
                        {itemDetails?.item_name}
                    </div>

                    <button
                        onClick={() => setShowModal(false)}
                        className="rounded-md p-2 text-gray-500 hover:bg-gray-100 hover:text-gray-700 transition"
                    >
                        ✕
                    </button>
                </div>

                {/* Body */}
                <div className="p-6 overflow-y-auto max-h-[75vh] tiny-scrollbar">
                    {detailsLoading ? (
                        <div className="flex flex-col items-center justify-center py-20">
                            <div className="h-10 w-10 animate-spin rounded-full border-4 border-gray-300 border-t-gray-700"></div>

                            <p className="mt-4 text-sm text-gray-600">
                                Loading details...
                            </p>
                        </div>
                    ) : detailsError ? (
                        <div className="flex flex-col items-center justify-center py-20">
                            <p className="text-sm font-medium text-red-500">
                                {detailsError}
                            </p>
                        </div>
                    ) : (
                        <>
                            <p className="mb-4 text-center text-sm text-gray-700">
                                From <strong>{itemDetails?.start_date}</strong> to{" "}
                                <strong>{itemDetails?.end_date}</strong>
                            </p>

                            <div className="overflow-x-auto rounded-xl border border-gray-200 tiny-scrollbar">
                                <table className="min-w-full divide-y divide-gray-200 text-sm">
                                    <thead className="sticky top-0 z-10 bg-gray-100">
                                        <tr>
                                            {[
                                                "Finished Item",
                                                "Recipe Name",
                                                "Produced Qty",
                                                "Batches",
                                                "Usage / Batch",
                                                "Sub Recipe",
                                                "Sub Usage",
                                                "Total Consumed",
                                                "UOM",
                                            ].map((col, idx) => (
                                                <th
                                                    key={idx}
                                                    className="whitespace-nowrap px-4 py-3 text-center text-xs font-semibold uppercase tracking-wider text-gray-700"
                                                >
                                                    {col}
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>

                                    <tbody className="divide-y divide-gray-100 bg-white">
                                        {itemDetails?.consumption_details?.details?.length > 0 ? (
                                            itemDetails.consumption_details.details.map(
                                                (detail, idx) => {
                                                    const subRecipes = detail.sub_recipes || [];

                                                    const rowCount =
                                                        subRecipes.length > 0
                                                            ? subRecipes.length
                                                            : 1;

                                                    return Array.from({
                                                        length: rowCount,
                                                    }).map((_, rowIndex) => {
                                                        const subRecipe =
                                                            subRecipes[rowIndex];

                                                        return (
                                                            <tr
                                                                key={`${idx}-${rowIndex}`}
                                                                className="transition hover:bg-gray-50"
                                                            >
                                                                {rowIndex === 0 && (
                                                                    <>
                                                                        <td
                                                                            rowSpan={rowCount}
                                                                            className="px-4 py-3 text-center font-medium text-gray-800"
                                                                        >
                                                                            {detail.finished_item}
                                                                        </td>

                                                                        <td
                                                                            rowSpan={rowCount}
                                                                            className="px-4 py-3 text-center"
                                                                        >
                                                                            {detail.recipe_name}
                                                                        </td>

                                                                        <td
                                                                            rowSpan={rowCount}
                                                                            className="px-4 py-3 text-center"
                                                                        >
                                                                            {Number(
                                                                                detail.total_produced || 0
                                                                            ).toFixed(2)}
                                                                        </td>

                                                                        <td
                                                                            rowSpan={rowCount}
                                                                            className="px-4 py-3 text-center"
                                                                        >
                                                                            {Number(
                                                                                detail.actual_batches || 0
                                                                            ).toFixed(2)}
                                                                        </td>

                                                                        <td
                                                                            rowSpan={rowCount}
                                                                            className="px-4 py-3 text-center"
                                                                        >
                                                                            {Number(
                                                                                detail.direct_usage_per_batch ||
                                                                                0
                                                                            ).toFixed(2)}
                                                                        </td>
                                                                    </>
                                                                )}

                                                                {/* Sub Recipe */}
                                                                <td className="px-4 py-3 text-center">
                                                                    {subRecipe?.sub_recipe_name ||
                                                                        (
                                                                            <span className="text-gray-400">
                                                                                -
                                                                            </span>
                                                                        )}
                                                                </td>

                                                                {/* Sub Usage */}
                                                                <td className="px-4 py-3 text-center">
                                                                    {subRecipe
                                                                        ? Number(
                                                                            subRecipe.calculated_quantity ||
                                                                            0
                                                                        ).toFixed(2)
                                                                        : "0.00"}
                                                                </td>

                                                                {/* Total */}
                                                                {rowIndex === 0 && (
                                                                    <>
                                                                        <td
                                                                            rowSpan={rowCount}
                                                                            className="px-4 py-3 text-center font-semibold text-gray-800"
                                                                        >
                                                                            {Number(
                                                                                detail.total_consumed || 0
                                                                            ).toFixed(2)}
                                                                        </td>

                                                                        <td
                                                                            rowSpan={rowCount}
                                                                            className="px-4 py-3 text-center"
                                                                        >
                                                                            {detail.new_uom ||
                                                                                detail.uom}
                                                                        </td>
                                                                    </>
                                                                )}
                                                            </tr>
                                                        );
                                                    });
                                                }
                                            )
                                        ) : (
                                            <tr>
                                                <td
                                                    colSpan={9}
                                                    className="px-4 py-8 text-center text-gray-500"
                                                >
                                                    No data available
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {/* Footer Summary */}
                            <div className="mt-4 text-right text-sm font-medium text-gray-700">
                                <span className="font-semibold">
                                    Total Produced:
                                </span>{" "}
                                {
                                    itemDetails?.consumption_details?.summary
                                        ?.total_consumed
                                }{" "}
                                {itemDetails?.consumption_details?.summary?.uom}
                            </div>
                        </>
                    )}
                </div>

                {/* Footer */}
                <div className="flex justify-end border-t px-6 py-4">
                    <button
                        onClick={() => setShowModal(false)}
                        className="rounded-lg bg-gray-700 px-5 py-2 text-sm font-medium text-white transition hover:bg-gray-800"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CentralKitchenInventoryModal;